import routes from "configs/dashboardRoutes";

export const useRouteName = () => {
  let name = "";
  routes.forEach((route) => {
    if (window.location.href.indexOf(route.path) !== -1) {
      name = routes.rtlActive ? route.rtlName : route.name;
    }
  });
  return name;
};

export const getTabElements = (routes) => {
  let tabs = [];
  let currentUrl = location.pathname;
  let splitUrl = currentUrl.split("/");
  if (splitUrl.length > 1) {
    splitUrl.shift();
    splitUrl = splitUrl.map((url) => {
      return "/" + url;
    });
    routes.forEach((route) => {
      if (route.path === splitUrl[0]) {
        if (route.items) {
          route.items.map((item) => {
            if (item.subItems && item.path === splitUrl[1]) {
              item.subItems.map((subItem) => {
                if (!subItem.noTab) {
                  tabs.push({
                    name: subItem.name,
                    url: route.path + item.path + subItem.path,
                    icon: subItem.icon,
                    radioInsideTab: subItem.radioInsideTab,
                  });
                }
              });
            }
          });
        }
      }
    });
  }
  return tabs;
};
